import { mrWolfUcpApi, mrWolfUserApi } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';

export const mrWolfApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getCourseAccessLevel: builder.query({
      query: ({ courseId, userId }) => ({
        url: mrWolfUcpApi(),
        method: 'POST',
        body: {
          data: { courseId, userId, type: 1 },
          method: 'list'
        }
      }),
      transformResponse: (response) => response.data,
      providesTags: (result, error, { courseId, userId }) => [
        { type: 'CourseAccess', id: `${courseId}-${userId}` }
      ]
    }),

    updateCourseAccessLevel: builder.mutation({
      query: ({ acessLevelId, role, userId }) => ({
        url: mrWolfUcpApi(),
        method: 'POST',
        body: {
          data: { id: acessLevelId, mode: role },
          method: 'update'
        }
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ['CourseAccess']
    }),

    incarnateSuggest: builder.query({
      query: ({ params }) => ({
        url: mrWolfUserApi(),
        method: 'POST',
        body: {
          data: { token: params },
          method: 'suggest'
        }
      }),
      transformResponse: (response) => response.data,
      providesTags: (result, error, { params }) => [
        { type: 'MrWolf', id: params }
      ]
    })
  }),
  overrideExisting: false,
});

export const {
  useGetCourseAccessLevelQuery,
  useUpdateCourseAccessLevelMutation,
  useLazyIncarnateSuggestQuery,
} = mrWolfApiSlice; 